let tokenKey = 'accessToken';

export const setTokenKey = (key) => {
  tokenKey = key;
};

export const getToken = () => localStorage.getItem(tokenKey);

export const setToken = (data) => localStorage.setItem(tokenKey, data);

export const removeToken = () => localStorage.removeItem(tokenKey);
